import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { fadeIn } from 'common'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

export const PrivacyPolicyPageLink = styled(Link)`
  display: flex;
  padding: 1rem 0;
  margin-top: 0.5rem;
  align-items: center;

  svg {
    display: flex;
    justify-content: right;
    align-items: flex-end;
  }

  span {
    color: var(--typography500);
    margin-left: 1rem;
    flex: 1;
  }
`

export const QuestionsSection = styled.section`
  min-height: 35vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
`

export const ShowMoreButton = styled(Button)`
  display: flex;
  justify-content: center;

  svg {
    transition: all 0.3s ease-out;
  }

  .up {
    transform: rotate(180deg);
  }

  .down {
    transform: rotate(0deg);
  }
`

export const NoResultsFoundError = styled(Text)`
  margin-top: 2rem;
  text-align: center;
  animation: ${fadeIn} 0.5s ease-out;
`
export const FooterTextContainer = styled.div`
  margin-bottom: 16px;
`
export const BottomCard = styled.div`
  width: 100vw;
  padding: 24px;
  user-select: none;
  display: flex;
  flex-direction: column;

  a {
    text-decoration: none;
  }
`
